module.exports = {
        srcSet: __webpack_public_path__ + "static/media/HowItWorkSection1-170.24533bed.webp"+" 170w",
        images: [{path: __webpack_public_path__ + "static/media/HowItWorkSection1-170.24533bed.webp",width: 170,height: 150}],
        src: __webpack_public_path__ + "static/media/HowItWorkSection1-170.24533bed.webp",
        toString: function(){return __webpack_public_path__ + "static/media/HowItWorkSection1-170.24533bed.webp"},
        
        width: 170,
        height: 150
      }